<template>
   <v-container fluid ma-0 pa-0 px-4 >
    <Loading :isLoading="loading">
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  New account
                </h2>
              </template>
                <span>New account</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Add details below to create a new Caseblock account</h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
      <v-flex xs12 pt-4>
        <v-layout style="background:white !important" class="px-4 py-4 mb-0 elevation-2 rounded-3">
          <v-layout row wrap pa-4>
            <v-flex xs12>
              <h2 class="mb-1">Details</h2>
            </v-flex>
            <v-flex
              xs12 md6
              :class="{'mt-3 pr-0 pb-4 ': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}">
              <v-text-field label="Account name" placeholder="e.g. Acme Corporation" box></v-text-field>
              <v-text-field
                hint="The nickname will be used in URL used to access the account e.g. http://acme.caseblocks.com."
                label="Nickname"
                placeholder="e.g. acme"
                box
                persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <h2 class="mb-1 mt-4">Technical Contact / Account Administrator</h2>
            </v-flex>
            <v-flex
              xs12 md6
              :class="{'mt-3 pr-0 pb-4 ': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}">
              <v-text-field label="Email" placeholder="e.g. jill@acme.com" box></v-text-field>
              <v-text-field label="Login" placeholder="e.g. jill" box></v-text-field>
              <v-text-field label="Display name" placeholder="e.g. Jill B." box></v-text-field>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-layout row fluid wrap>
        <v-spacer></v-spacer>
        <v-btn class="mt-4 ml-0" color="secondary">Back to all accounts</v-btn>
        <v-btn class="mt-4 mb-0 mx-0" color="success" id="newaccount-save-btn">Save new account</v-btn>
      </v-layout>
    </Loading>
  </v-container>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "new-account",
  data: () => {
    return {
      loading: false
    }
  },
  components: {
    Loading
  }
}
</script>
